import { createContext } from 'react';
import { ProseMirrorView } from '../../../shared/types/types';

const ProseMirrorEditorViewContext = createContext<ProseMirrorView>({ page: '', editorView: '' });

export default ProseMirrorEditorViewContext;
